import { Team } from "@brg/api";

export enum RepostTabs {
    feed = 'feed',
    mediiia = 'mediiiia',
    delete = 'delete'
}

export enum REPOST_MODE {
    add = 'add',
    edit = 'edit',
    delete = 'delete'
}

export const DEFAULT_TABS = [
    {
        value: RepostTabs.feed,
        name: [{ lang: 'ru', name: 'Материалы подписок'}, { lang: 'en', name: 'feed'}]
    },
];

export const getFindTab = (arr: Team<'Global'>[], projectId: string) => {
    const channel = arr?.find((i) => {
        const intoMainFilter = i?.mainFilter?.projectIds?.includes(projectId)
        const intoTabsFilter = i?.tabs?.find((tab) => tab?.filter?.projectIds?.includes(projectId))
        return intoMainFilter || intoTabsFilter
    })

    if (channel?.tabs?.length) {
        return channel?.tabs?.find((tab) => tab?.filter?.projectIds?.includes(projectId))
    }

    return channel?.mainFilter
}

export type OptionWithAddT = {
    label: string,
    value: string,
    addOptions: any[]
}

export type OptionActiveT= {
    label: string,
    value: string,
    parent: {
        label: string,
        value: string,
    } | null
}import { Team } from "@brg/api";

export enum RepostTabs {
    feed = 'feed',
    mediiia = 'mediiiia',
    delete = 'delete'
}

export enum REPOST_MODE {
    add = 'add',
    edit = 'edit',
    delete = 'delete'
}

export const DEFAULT_TABS = [
    {
        value: RepostTabs.feed,
        name: [{ lang: 'ru', name: 'Материалы подписок'}, { lang: 'en', name: 'feed'}]
    },
];

export const getFindTab = (arr: Team<'Global'>[], projectId: string) => {
    const channel = arr?.find((i) => {
        const intoMainFilter = i?.mainFilter?.projectIds?.includes(projectId)
        const intoTabsFilter = i?.tabs?.find((tab) => tab?.filter?.projectIds?.includes(projectId))
        return intoMainFilter || intoTabsFilter
    })

    if (channel?.tabs?.length) {
        return channel?.tabs?.find((tab) => tab?.filter?.projectIds?.includes(projectId))
    }

    return channel?.mainFilter
}

export type OptionWithAddT = {
    label: string,
    value: string,
    addOptions: any[]
}

export type OptionActiveT= {
    label: string,
    value: string,
    parent: {
        label: string,
        value: string,
    } | null
}